module.exports = "<p>\n  cv works!\n</p>\n"